.cta {
  background: linear-gradient(#d9232dc0, #d9232dc0), url('./congrats.jpg') fixed center center;
  background-size: cover;
  padding: 120px 0;
}

.cta h3 {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

.cta p {
  color: #fff;
}

.cta .ctaBtn {
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 12px 40px;
  border-radius: 50px;
  transition: 0.5s;
  margin: 10px;
  border: 2px solid #fff;
  color: #fff;
}

.cta .ctaBtn:hover {
  background: #a10d0d;
  border: 2px solid #a10d0d;
}

@media (max-width: 1024px) {
  .cta {
    background-attachment: scroll;
  }
}

@media (min-width: 769px) {
  .cta .ctaBtnContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
